import React from 'react';
import { connect } from 'react-redux';
import { verificarPregunta } from './servicios.act';
import { movil } from '../app-movil';
import { cambiarContrasena } from './datos.act';

const mapState = (state) => {
    return {
    	preguntaUno: state.miPerfil.preguntaUno,
		preguntaUnoText: state.miPerfil.preguntaUnoText,
		preguntaDos: state.miPerfil.preguntaDos,
		preguntaDosText: state.miPerfil.preguntaDosText,
		newpass: state.miPerfil.newPass,
		preguntas1: state.catalogos.objetoPregunta1,
		preguntas2: state.catalogos.objetoPregunta2,
		loadLocal: state.miPerfil.loadLocal,
		dispositivo: state.global.dispositivo
    };
}

const mapDispatch = (dispatch) => {
    return {
    	resetSiguienteContrasena: () => {
            dispatch({ "type": "MI_PERFIL_RESET_SIGUIENTE_CONTRASENA" });
        },
        setEnc: (texto) => {
        	dispatch({ "type": "MI_PERFIL_SET_ENC", "text": texto});
        },
        setMsj: (texto) => {
        	dispatch({ "type": "MI_PERFIL_SET_MSJ", "text": texto});
        },
        pasoSiguienteContrasena: () => {
            dispatch({ "type": "MI_PERFIL_PASO_SIGUIENTE_CONTRASENA" });
        },
        cambiarContrasena: (datos) => {
            dispatch(cambiarContrasena(datos));
        },
        setloadLocal: (val) => {
            dispatch({ "type": "MI_PERFIL_SET_LOAD_LOCAL", load: val });
        }
    }
}

class PasoDosContrasena extends React.Component {
	state = {
		inputClassPreguntaPass: "input-wrap",
		inputClassPreguntaPass2: "input-wrap",
		inputActivePreguntaPass: "",
		inputActivePreguntaPass2: "",
		inputPreguntaPassType: "password",
		inputPreguntaPassType2: "password",
		preguntaCambiarContrasena1: this.props.preguntaUnoText,
		pId1: this.props.preguntaUno,
		preguntaCambiarContrasena2: this.props.preguntaDosText,
		pId2: this.props.preguntaDos,
		errorPregunta: false,
		intentoPregunta: 1,
		errorPreguntaContrasena: false,
		errorMsjPreguntaContrasena: "",
		errorPreguntaContrasena2: false,
		errorMsjPreguntaContrasena2: ""
	}

	handleFocus = (event) => {
		let id = event.target.id;
        switch(id) {
        	case "inputPreguntaPass":
                this.setState({inputActivePreguntaPass: "input-active"});
                this.setState({errorPreguntaContrasena: false});
                this.setState({errorMsjPreguntaContrasena: ""});
                break;
            case "inputPreguntaPass2":
                this.setState({inputActivePreguntaPass2: "input-active"});
                this.setState({errorPreguntaContrasena2: false});
                this.setState({errorMsjPreguntaContrasena2: ""});
                break;
        }
	}
	handleBlur = (event) => {
		let id = event.target.id;
        let valor = event.target.value;
        switch(id) {
        	case "inputPreguntaPass":
                this.setState({inputActivePreguntaPass: valor ? "input-active" : ""});
                break;
            case "inputPreguntaPass2":
                this.setState({inputActivePreguntaPass2:valor ? "input-active" : ""});
                break;
        }
	}
	toggleType = (event) => {
		let id = event.target.id;
        let type;
        switch(id) {
        	case "ojoPreguntaPass":
                type = this.state.inputPreguntaPassType;
                this.setState({inputPreguntaPassType: type == "password" ? "text" : "password"});
                this.setState({inputClassPreguntaPass: type == "password" ? "input-wrap visible-input" : "input-wrap ver-input"});
                break;
            case "ojoPreguntaPass2":
                type = this.state.inputPreguntaPassType2;
                this.setState({inputPreguntaPassType2: type == "password" ? "text" : "password"});
                this.setState({inputClassPreguntaPass2: type == "password" ? "input-wrap visible-input" : "input-wrap ver-input"});
                break;
        }
	}
	okContrasena = () => {
        let mensaje = {"return": "miPerfil", "proceso": "cambioContrasena"};
        movil("cambioContrasena", mensaje);
        this.props.resetSiguienteContrasena();
        this.setState({inputClassPassOld: "input-wrap ver-input"});
        this.setState({inputClassPassNew: "input-wrap ver-input"});
        this.setState({inputClassPassNewConf: "input-wrap ver-input"});
        this.setState({inputClassPreguntaPass: "input-wrap"});
        this.setState({inputClassPreguntaPass2: "input-wrap"});
        this.setState({inputActivePassOld: ""});
        this.setState({inputActivePassNew: ""});
        this.setState({inputActivePassNewConf: ""});
        this.setState({inputActivePreguntaPass: ""});
        this.setState({inputPassOldType: "password"});
        this.setState({inputPassNewType: "password"});
        this.setState({inputPassNewConfType: "password"});
        this.setState({inputPreguntaPassType: "password"});
        this.setState({inputPreguntaPassType2: "password"});
        this.setState({oldPass: ""});
        this.setState({newPass: ""});
        this.setState({confPass: ""});
        this.setState({errorPregunta: false});
        this.setState({errorPreguntaContrasena: false});
        this.setState({errorPregunta2: false});
        this.setState({errorPreguntaContrasena2: false});
        this.setState({intentoPregunta: 1});
        this.setState({preguntaCambiarContrasena: ""});
        this.setState({errorMsjPreguntaContrasena: ""});
        this.refs.respuesta1.value = "";
        this.refs.respuesta2.value = "";
        $('#modal-editar-contrasena').modal('toggle');
    }
    revisarPregunta = () => {
        let pregunta1 = this.state.pId1;
        let pregunta2 = this.state.pId2;
        let respuesta1 = this.refs.respuesta1.value;
        let respuesta2 = this.refs.respuesta2.value;
        let obj = {
            pass: this.props.newpass,
            p1: pregunta1,
            p2: pregunta2,
            r1: respuesta1,
            r2: respuesta2
        }
        if(!respuesta1) {
            this.setState({errorPreguntaContrasena: true});
            this.setState({errorMsjPreguntaContrasena: "Campo requerido."});
        }
        if(!respuesta2) {
            this.setState({errorPreguntaContrasena2: true});
            this.setState({errorMsjPreguntaContrasena2: "Campo requerido."});
        }
        if(respuesta1 && respuesta2)
        {
            this.props.setloadLocal(true);
            obj.dispositivo = this.props.dispositivo;
            this.props.cambiarContrasena(obj);
        }
    }

	render() {
		return <div>
            <h5>
                <i>
                    <img src={ require("../img/delete-pass.png") } />
                </i>Modificar contraseña
            </h5>
            { this.state.errorPregunta &&
                <div className="msj-warning">
                    <i><img src={ require("../img/exclamation-naranja.png") } /></i>
                    <span>
                        <p>¡IMPORTANTE!</p>
                        <p>Tu respuesta fue incorrecta para realizar tu cambio contesta la siguiente pregunta secreta.</p>
                    </span>
                </div>
            }
            <hr className="mt-34" />
            { this.props.loadLocal &&
            <div className="table-center">
                     <img src={ require("../img/load_mini.gif") } />
            </div>
            }
            { !this.props.loadLocal &&
            <div>
            <div className="texto-17">
                <p>Para realizar tu cambio de contraseña contesta las siguientes preguntas secretas.</p>
            </div>
            <div className="row">
                <div className="col-xs-12 col-md-10 col-md-offset-1">
                    <div className="row">
                        <div className="col-xs-12 mt-34">
                            <div className="input-wrap">
                                <label>Pregunta secreta 1</label>
                                <p>{this.props.preguntas1[this.props.preguntaUno]}</p>
                            </div>
                        </div>
                        <div className="col-xs-12">
                            <div className={this.state.inputClassPreguntaPass}>
                                <label>Respuesta</label>
                                <span className={this.state.inputActivePreguntaPass}>
                                    <input ref="respuesta1" id="inputPreguntaPass" type={this.state.inputPreguntaPassType} onFocus={this.handleFocus} onBlur={this.handleBlur} />
                                </span>
                                { this.state.errorPreguntaContrasena && 
                                    <div className="error-wrap">
                                        <div className="msj-error">
                                            <p>{this.state.errorMsjPreguntaContrasena}</p>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="col-xs-12 mt-34">
                            <div className="input-wrap">
                                <label>Pregunta secreta 2</label>
                                <p>{this.props.preguntas2[this.props.preguntaDos]}</p>
                            </div>
                        </div>
                        <div className="col-xs-12">
                            <div className={this.state.inputClassPreguntaPass2}>
                                <label>Respuesta</label>
                                <span className={this.state.inputActivePreguntaPass2}>
                                    <input ref="respuesta2" id="inputPreguntaPass2" type={this.state.inputPreguntaPassType2} onFocus={this.handleFocus} onBlur={this.handleBlur} />
                                </span>
                                { this.state.errorPreguntaContrasena2 &&
                                    <div className="error-wrap">
                                        <div className="msj-error">
                                            <p>{this.state.errorMsjPreguntaContrasena2}</p>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="col-xs-12">
                            <div className="text-center aceptar-cancelar-btn">
                                <a onClick={this.okContrasena}>Cancelar</a>
                                <a className="orange-btn" onClick={this.revisarPregunta}>Aceptar</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
            }
        </div>
	}
}

export default connect(mapState, mapDispatch)(PasoDosContrasena);



// WEBPACK FOOTER //
// ./src/miPerfil/pasoDosContrasena.cmpt.js